import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeavingComponent } from './leaving.component';
import {HighchartsChartModule} from "highcharts-angular";
import {AlertBannerModule} from "../../lib/alert-banner";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";



@NgModule({ declarations: [LeavingComponent],
    exports: [LeavingComponent], imports: [BrowserModule,
        FormsModule,
        CommonModule,
        HighchartsChartModule,
        AlertBannerModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class LeavingModule { }
